import { FC } from "react"
import clsx from "clsx"

import { useTimezone } from "hooks/useTimezone"

import { TagRule } from "services/tags/type"

export const RulesTable: FC<{
  rows: TagRule[]
  loading: boolean
  onEdit: (r: TagRule) => void
  onDelete: (id: string) => void
  onRun: (id: string) => void
}> = ({ rows, loading, onEdit, onDelete, onRun }) => {
  const { formatDateTime } = useTimezone()

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table w-full text-black dark:text-white">
        <thead className="text-black/70 dark:text-white/80">
          <tr>
            <th>Name</th>
            <th>Tag</th>
            <th>Mode</th>
            <th>Active</th>
            <th>Priority</th>
            <th>Last run</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7}>
                <div className="flex items-center gap-2">
                  <span className="loading loading-spinner loading-md" />
                  <span>Loading...</span>
                </div>
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={7} className="opacity-70">
                No rules found
              </td>
            </tr>
          ) : (
            rows
              .slice()
              .sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0) || a.name.localeCompare(b.name))
              .map((r) => (
                <tr key={r.id} className="hover:bg-black/5 dark:hover:bg-white/5">
                  <td className="font-medium">{r.name}</td>
                  <td className="opacity-80">{r.tag?.name ?? r.tag_id}</td>
                  <td>{String(r.evaluationMode).toUpperCase()}</td>
                  <td>{r.isActive ? "Yes" : "No"}</td>
                  <td>{r.priority ?? 0}</td>
                  <td className="opacity-70">{r.last_run_at ? formatDateTime(r.last_run_at) : "-"}</td>
                  <td className="text-right">
                    <div className="flex justify-end gap-2">
                      <button className="btn btn-xs btn-outline" onClick={() => onRun(r.id)}>
                        Run
                      </button>
                      <button className="btn btn-xs" onClick={() => onEdit(r)}>
                        Edit
                      </button>
                      <button className={clsx("btn btn-xs btn-error")} onClick={() => onDelete(r.id)}>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
          )}
        </tbody>
      </table>
    </div>
  )
}
